<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card card-top-line">
          <ValidationObserver v-slot="{ passes }">
            <div class="header">
              <h2>Send Email and Messages</h2>
            </div>
            <div class="body">
              <form
                @submit.prevent="passes(sendnotificationSubmit)"
                id="basic-form"
              >
                <div class="body">
                  <ValidationProvider
                    name="type"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div class="country-dropdown">
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            sendnotification.type &&
                            sendnotification.type.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="Country">Select Notification Type*</label>
                          <multiselect
                            placeholder=""
                            v-model="sendnotification.type"
                            :show-labels="false"
                            :options="notification_types"
                            :searchable="false"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              sendnotification.type &&
                              sendnotification.type.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                    name="customer"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-group"
                      :class="{
                        errors: errors.length && !sendnotification.customer,
                        success: sendnotification.customer,
                      }"
                    >
                      <span class="float-label">
                        <input
                          type="text"
                          v-model="sendnotification.customer"
                          class="form-control"
                          id="customer"
                          placeholder="Company Name*"
                        />
                        <label for="customer" class="control-label">
                          Select Customer*
                        </label>
                        <div class="line"></div>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && !sendnotification.customer"
                        ></i>
                        <i
                          class="fa fa-check"
                          v-if="sendnotification.customer"
                        ></i>
                      </span>
                    </div>
                  </ValidationProvider>
                  <!-- Push Notification -->
                  <template v-if="sendnotification.type == 'Push Notification'">
                    <ValidationProvider
                      name="push_notification_title"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !push_notification.title,
                          success: push_notification.title,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="push_notification.title"
                            class="form-control"
                            id="push_notification"
                            placeholder="Company Name*"
                          />
                          <label for="push_notification" class="control-label">
                            Push Notification Title*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !push_notification.title"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="push_notification.title"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="push_notification_content"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !push_notification.content,
                          success: push_notification.content,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            type="text"
                            v-model="push_notification.content"
                            class="form-control"
                            id="push_notification_content"
                            placeholder="Company Name*"
                          ></textarea>
                          <label
                            for="push_notification_content"
                            class="control-label"
                          >
                            Push Notification Content*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !push_notification.content"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="push_notification.content"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="push_notification_image"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !push_notification.image,
                          success: push_notification.image,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="push_notification.image"
                            class="form-control"
                            id="push_notification_image"
                            placeholder="Company Name*"
                          />
                          <label
                            for="push_notification_image"
                            class="control-label"
                          >
                            Push Notification Image*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !push_notification.image"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="push_notification.image"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                  </template>
                  <!-- Push Notification -->

                  <!-- Email -->
                  <template v-if="sendnotification.type == 'Email'">
                    <ValidationProvider
                      name="email_notification_subject"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !email_notification.subject,
                          success: email_notification.subject,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="email_notification.subject"
                            class="form-control"
                            id="email_notification"
                            placeholder="Company Name*"
                          />
                          <label for="email_notification" class="control-label">
                            Email subject*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !email_notification.subject"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="email_notification.subject"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="email_notification_content"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !email_notification.content,
                          success: email_notification.content,
                        }"
                      >
                        <label
                          for="email_notification_content"
                          class="control-label"
                        >
                          Email Content*
                        </label>
                        <span class="float-label">
                          <vue-editor
                            v-model="email_notification.content"
                          ></vue-editor>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !email_notification.content"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="email_notification.content"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                  </template>
                  <!-- Email -->

                  <!-- SMS -->
                  <template v-if="sendnotification.type == 'SMS'">
                    <ValidationProvider
                      name="sms_notification_content"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !sms_notification.content,
                          success: sms_notification.content,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            type="text"
                            v-model="sms_notification.content"
                            @input="handleEditorInput"
                            @keydown="handleKeyDown"
                            class="form-control"
                            id="sms_notification_content"
                            placeholder="Company Name*"
                          ></textarea>
                          <label
                            for="sms_notification_content"
                            class="control-label"
                          >
                            SMS Content*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !sms_notification.content"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="sms_notification.content"
                          ></i>
                        </span>
                        <p class="text-right">
                          {{ sms_notification.content.length }}/320
                        </p>
                      </div>
                    </ValidationProvider>
                  </template>
                  <!-- SMS -->
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.back()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { VueEditor } = require("vue2-editor");
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "@/plugins/vee-validate";
import { mapState, mapGetters } from "vuex";
export default {
  name: "SendSingleRemitterEmail",
  components: {
    BreadCrumb,
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import("vue-multiselect"),
    VueEditor,
  },
  data() {
    return {
      sendnotification: {
        type: "",
        customer: "",
      },
      push_notification: {
        title: "",
        content: "",
        image: "",
      },
      email_notification: {
        subject: "",
        content: "",
      },
      sms_notification: {
        content: "",
      },
      notification_types: ["Email", "SMS", "Push Notification"],
    };
  },
  methods: {
    sendnotificationSubmit() {
      console.log(this.remitterCredits);
      console.log(this.selectedOptions);
    },
    handleEditorInput() {
      if (this.sms_notification.content.length > 320) {
        // Truncate the content to the maximum allowed characters
        this.sms_notification.content = this.sms_notification.content.slice(
          0,
          320,
        );
      }
    },

    handleKeyDown(event) {
      if (
        this.sms_notification.content.length >= 320 &&
        event.key !== "Backspace"
      ) {
        // Prevent typing beyond the character limit
        event.preventDefault();
      }
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
